import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumb = ({ items }) => (
  <nav aria-label="Breadcrumb" className="flex items-center flex-wrap gap-1 text-xs sm:text-sm text-slate-500 mb-2" data-testid="breadcrumb">
    {items.map((it, i) => (
      <React.Fragment key={i}>
        {i > 0 && <ChevronRight className="h-3.5 w-3.5 text-slate-400" />}
        {it.to ? <Link to={it.to} className="hover:text-[hsl(224,64%,33%)] hover:underline" data-testid={`breadcrumb-${i}`}>{it.label}</Link>
          : <span className="font-medium text-slate-700" data-testid={`breadcrumb-${i}`}>{it.label}</span>}
      </React.Fragment>
    ))}
  </nav>
);
